<template>
  <v-card
    id="screenshot-box"
    width="550px"
    class="mb-2"
  >
    <v-card-text v-if="browserIsSafari">
      <v-alert type="error">
        Die Screenshot-Funktion ist im Safari-Browser leider nicht verfügbar.
        Bitte verwenden Sie hierfür eine aktuelle Version eines anderen Browsers
        (z.B. Chrome/Chromium, Firefox, Microsoft Edge).
      </v-alert>
    </v-card-text>
    <v-card-text v-else>
      <v-text-field
        v-model="fileName"
        label="Dateiname"
        suffix=".pdf"
      >
        <template v-slot:append-outer>
          <v-btn
            fab
            small
            @click="screenshot"
          >
            <v-icon>fa-camera</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
import Bowser from "bowser";
import { jsPDF } from "jspdf";
import domtoimage from "dom-to-image";
import slugify from "slugify";

export default {
  name: "Screenshot",
  data() {
    return {
      // default screenshot file name
      fileName: this.generateFileName()
    };
  },
  computed: {
    browserIsSafari() {
      return (
        Bowser.getParser(window.navigator.userAgent).getBrowserName() ==
        "Safari"
      );
    }
  },
  methods: {
    generateFileName() {
      var fn = "";
      if (this.$store.state.selectedUpdate) {
        fn +=
          this.$store.state.selectedUpdate.description +
          `-${this.$store.state.selectedUpdate.dateOfUpdate.slice(0, 10)}` +
          `_${this.$store.getters.selectedYear}__`;
      }
      fn += new Date().toISOString().slice(0, 10);
      return slugify(fn);
    },
    // take screenshot of map and render to pdf
    async screenshot() {
      document.body.style.cursor = "progress";

      // bottom nav bar needs to be hidden
      this.$emit("hideBottomControls");

      // take screenshot of map container
      var mapNode = document.getElementById("map-container");
      var image = await domtoimage.toJpeg(mapNode);

      // render screenshot to pdf
      var pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        hotfixes: ["px_scaling"],
        format: [mapNode.scrollWidth, mapNode.scrollHeight]
      });
      pdf.addImage(
        image,
        "JPEG",
        0,
        0,
        mapNode.scrollWidth,
        mapNode.scrollHeight
      );

      // add info text box to pdf
      pdf.setFontSize(10);
      var texts = [
        `Szenario: ${this.$store.state.selectedUpdate.description}`,
        `Berechnung: ${new Date(
          this.$store.state.selectedUpdate.dateOfUpdate
        ).toString()}`,
        `User: ${this.$store.state.user.name}`,
        `Download: ${new Date().toString()}`
      ];
      var rectWidth =
        Math.max(...texts.map(text => pdf.getTextDimensions(text).w)) + 20;
      var rectHeight =
        texts.reduce((sum, text) => sum + pdf.getTextDimensions(text).h, 0) +
        20;
      pdf.setFillColor(255);
      pdf.rect(0, 0, rectWidth, rectHeight, "F");
      pdf.text(10, 20, texts);

      document.body.style.cursor = "auto";
      this.$emit("showBottomControls");

      // download pdf
      pdf.save(`${this.fileName}.pdf`);
    }
  }
};
</script>
